import { render, staticRenderFns } from "./userHelpDetail.vue?vue&type=template&id=087175e7&scoped=true"
import script from "./userHelpDetail.vue?vue&type=script&lang=js"
export * from "./userHelpDetail.vue?vue&type=script&lang=js"
import style0 from "./userHelpDetail.vue?vue&type=style&index=0&id=087175e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087175e7",
  null
  
)

export default component.exports